import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'goober';

import { Flexbox } from '@/ui/flexbox/flexbox';
import { colorIcon } from '@/ui/icons/functions';
import { Icon } from '@/ui/icons/icon';
import { SlidingSidebar } from '@/ui/sliding-sidebar/sliding-sidebar';

import { useSidebars } from '@/hooks/use-sidebars';
import { TemplateCard } from './template-card';
import { useTemplates } from '../settings/manage-templates/use-templates.query';

export const TemplatesSidebar = () => {
  const { t } = useTranslation('default', { keyPrefix: 'templatesSidebar' });

  const { data = [] } = useTemplates();

  const { resetSidebar, isTemplatesSidebarOpen } = useSidebars();

  if (!isTemplatesSidebarOpen) return null;

  return (
    <SlidingSidebar transition>
      <Container name="templates-sidebar-container" direction="column">
        <Header
          name="templates-sidebar-header"
          alignItems="center"
          justify="space-between"
          padding="16px 32px 0 32px"
        >
          <TitleContainer
            name="templates-sidebar-title"
            alignItems="center"
            gap="24px"
            onClick={resetSidebar}
          >
            <Icon icon="ArrowLeft2" />
            <TitleValue>{t`title`}</TitleValue>
          </TitleContainer>
        </Header>
        {data.map(template => (
          <TemplateCard key={template.id} template={template} />
        ))}
      </Container>
    </SlidingSidebar>
  );
};

const Container = styled(Flexbox)`
  --slidingSidebarHeight: calc(72px - 10px);
  box-shadow: ${({ theme }) => theme.shadow.actionsPanel};
  height: calc(100vh - var(--slidingSidebarHeight));
`;

const Header = styled(Flexbox)`
  background-color: ${({ theme }) => theme.colors.basics.white};
`;

const TitleContainer = styled(Flexbox)`
  ${({ theme }) => theme.typography.actionsPanel.acrossPanel.inPlatformLocation}
  ${({ theme }) => colorIcon(theme.colors.basics.black)}
  cursor: pointer;
  height: 75px;
`;

const TitleValue = styled('div', forwardRef)`
  ${({ theme }) => theme.mixins.ellipsis}
  max-width: 420px;
`;
